module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp23_8019.a92b5e7e.png";